import {initializeIntlTelInput} from "./utils/telInput";

let firstStep = document.getElementById("registration-first-step");
let secondStep = document.getElementById("registration-second-step");

let individualTrigger = document.getElementById("individual-trigger");
let organizationTrigger = document.getElementById("organization-trigger");

let isBusiness = document.getElementById("registration_form_business");

let companyName = document.querySelector(".registration_form_companyName-group");
let companyNameInput = document.getElementById("registration_form_companyName");
let vatNumber = document.querySelector(".registration_form_vatNumber-group");
let vatNumberInput = document.getElementById("registration_form_vatNumber");

let fullName = document.querySelector(".registration_form_fullName-group");
let fullNameInput = document.getElementById("registration_form_fullName");
let birthDate = document.querySelector(".registration_form_birthdate-group");
let birthDateInput = document.getElementById("registration_form_birthdate");

let errors = document.querySelectorAll(".form-error-message");
let hasErrors = errors && errors.length;

individualTrigger.addEventListener("click", function () {
    showSecondStep()
    isBusiness.checked = false;

    organizationTrigger.classList.remove("btn-primary");
    organizationTrigger.classList.add("btn-outline-primary");
    individualTrigger.classList.remove("btn-outline-primary");
    individualTrigger.classList.add("btn-primary");

    console.log("individual");

    fullName.style.display = "block";
    fullNameInput.required = true;
    birthDate.style.display = "block";
    birthDateInput.required = true;

    companyName.style.display = "none";
    companyNameInput.required = false;
    vatNumber.style.display = "none";
    vatNumberInput.required = false;
});

organizationTrigger.addEventListener("click", function () {
    showSecondStep();
    isBusiness.checked = true;

    individualTrigger.classList.remove("btn-primary");
    individualTrigger.classList.add("btn-outline-primary");
    organizationTrigger.classList.remove("btn-outline-primary");
    organizationTrigger.classList.add("btn-primary");

    console.log("organization");

    companyName.style.display = "block";
    companyNameInput.required = true;
    vatNumber.style.display = "block";
    vatNumberInput.required = true;

    fullName.style.display = "none";
    fullNameInput.required = false;
    birthDate.style.display = "none";
    birthDateInput.required = false;
});

if (hasErrors) {
    showSecondStep();

    if (isBusiness.checked) {
        organizationTrigger.click();
    } else {
        individualTrigger.click();
    }
}

function showSecondStep() {
    secondStep.style.display = "block";
}

initializeIntlTelInput();
